<script setup>
import { computed } from 'vue';
import LetPage from '@/letapps-vue/components/LetPage';
import { useRoute } from 'vue-router';
import TagDetail from './TagDetail.vue';

const route = useRoute();
const tagId = computed(() => Number(route.params.id));
</script>

<template>
  <LetPage fit>
    <TagDetail :tagId="tagId" />
  </LetPage>
</template>

<style scoped lang="scss"></style>
